export const SET_DO_EXPORT_CLICK= "SET_DO_EXPORT_CLICK";
export const SET_DO_EXPORT_DONE= "SET_DO_EXPORT_DONE";
export const SET_DO_EXPORT_ERROR= "SET_DO_EXPORT_DONE";
export const SET_LOADING_REPORT_HISTORY_ERROR= "SET_LOADING_REPORT_HISTORY_ERROR";
export const SET_LOADING_REPORT_HISTORY_DONE= "SET_LOADING_REPORT_HISTORY_DONE";
export const EXPORT_ORDER_DONE= "EXPORT_ORDER_DONE";
export const LOADING= "LOADING";